<!-- <p *ngIf="!this.masternotselected">You Have not selected the right format on devices </p> -->
<p *ngIf="this.masternotselected">{{errMsg}}</p>



<span >
    <button  class="primary_btn" mat-raised-button type="button"
      (click)="onclickclose()">close
    </button>
  </span>
